import { PRIVATE_URIS } from '../constants/privateURIs.constants';

/**
 * Builds the per-post Sentiment Map route from its PRIVATE_URIS template,
 * keeping the '/post/:postId/sentiment' shape in a single source of truth.
 */
export function postSentimentPath(postId: string): string {
  return PRIVATE_URIS.POST_SENTIMENT.replace(':postId', postId);
}
